// The front page: Home for someone signed in, the welcome page for anyone else.
import { useAuth } from '../../auth';
import { Home } from './Home';
import { Welcome } from './Welcome';

export function Front() {
  return useAuth().session('owners') ? <Home /> : <Welcome />;
}
